export const ORG_SWITCHER_ORGANIZATIONS_KEY = ['orgSwitcher', 'organizations'] as const;
export const orgSwitcherOrgsKey = (search: string) => [...ORG_SWITCHER_ORGANIZATIONS_KEY, search] as const;

export const ORG_SWITCHER_PROJECTS_KEY = ['orgSwitcher', 'projects'] as const;

export const ORG_SWITCHER_CURRENT_PROJECT_KEY = ['orgSwitcher', 'currentProject'] as const;
